import { render, staticRenderFns } from "./PageTag.vue?vue&type=template&id=616184fc&scoped=true"
import script from "./PageTag.vue?vue&type=script&lang=js"
export * from "./PageTag.vue?vue&type=script&lang=js"
import style0 from "./PageTag.vue?vue&type=style&index=0&id=616184fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616184fc",
  null
  
)

export default component.exports